export default __webpack_public_path__ + "static/media/crypto.6c85f24d.png";